var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "accessory",
      class: { selected: _vm.accessoryProp == _vm.accessorySelected },
      on: { click: _vm.onAccessorySelected }
    },
    [
      _c("img", {
        staticClass:
          "img product-options__img product-options__img--accessory product-options__img--selection",
        attrs: {
          src: _vm.accessoryProp.thumbnail,
          alt: _vm.accessoryProp.title
        }
      }),
      _vm._v(" "),
      _c("p", { staticClass: "product-options__title" }, [
        _vm._v(_vm._s(_vm.accessoryProp.title))
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }